import React from 'react';

const CodeBlock = ({ block, onChange }) => {
  return (
    <div>
      <textarea
        rows={6}
        placeholder="Write your code here"
        style={{ fontFamily: 'monospace', width: '100%' }}
        value={block.content}
        onChange={(e) => onChange({ ...block, content: e.target.value })}
      />
    </div>
  );
};

export default CodeBlock;
